import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import Loader from './../../components/Loader';

const ExoticsViewer = React.lazy(() => import('./../../_Projects/Exotics'));

const Routes = () => {
  return (
    <Suspense fallback={<Loader visible={true} />}>
      <Switch>
        <Route exact path='/exotics'>
          <ExoticsViewer />
        </Route>
        <Route exact path='/'>
          <ExoticsViewer />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default Routes;
